import React, { memo } from "react";
import { useSelector } from "react-redux";
import DataDisplay from "../../../../components/dataDisplay/dataDisplay";

export const DataPoints = memo(function DataPoints() {
  const dataPoints = useSelector((state) => state.checkIn.graphData.total_checkins_data);

  if (!dataPoints.length) return null;

  return (
    <div className="data-points">
      {dataPoints.map((dataPoint) => {
        return (
          <div key={dataPoint.label} className="data-point">
            <DataDisplay
              key={dataPoint.label}
              label={dataPoint.label}
              value={Math.round(dataPoint.total_checkins)}
              url={dataPoint.url}
              changeProps={{
                changeValue: dataPoint.growth / 100,
                toolTip: "Percentage change from previous period",
                showBorder: true
              }}
            />
          </div>
        );
      })}
    </div>
  );
});
